<template>
	<b-row class="m-0">
		<b-col class="p-0">
			<fieldset :disabled="isFormDisabled">
				<b-row class="m-0">
					<b-col lg="6" md="12">
						<div class="mh-profile-label">
							<div class="mh-img-wrap">
								<ProfileImage :imageUrl="profilePicture" />
								<span class="mh-user-online"></span>
							</div>
							<span class="mh-title">{{profile.email}}</span>
						</div>
					</b-col>
				</b-row>
				<b-row v-if="isTimeClockShift" class="m-0">
					<b-col lg="6" md="12">
						<label class="mh-label">Type</label>
						<div class="switches-container">
							<input type="radio" id="time" value="time" checked="checked" v-model="duration" @change="onDurationChange" />
							<input type="radio" id="duration" value="duration" v-model="duration" @change="onDurationChange" />
							<label for="time">Time In / Out</label>
							<label for="duration">Duration</label>
							<div class="switch-wrapper">
								<div class="switch">
									<div>Time In / Out</div>
									<div>Duration</div>
								</div>
							</div>
						</div>
					</b-col>
					<b-col v-if="duration == 'time'" lg="6" md="12">
						<label class="mh-label">Status</label>
						<div @click="onStatusClick" :class="`mh-entries-status${(!isCurrentlyWorking ? ' inactive' : '')}`">
							<i v-if="isCurrentlyWorking" class="mh-icon-tick"></i>
							<i v-else></i>
							<span>Currently Working</span>
						</div>
					</b-col>
				</b-row>
				<b-row v-if="isTimeClockShift" class="m-0">
					<b-col md="12">
						<label class="mh-label required">Name</label>
						<b-input type="text" v-model="name" />
					</b-col>
				</b-row>
				<b-row v-if="isTimeClockShift" class="m-0">
					<b-col :md="duration == 'duration' ? '12' : '6'">
						<label class="mh-label required">Time In</label>
						<div class="mh-time-entry">
							<div class="mh-datepicker">
								<datepicker v-model="dateFrom" :disabled-dates="isEmployee ? { from: moment().toDate() } : undefined" @input="onDateFromChange" />
								<i class="mh-icon-calendar"></i>
							</div>
							<div class="pl-2 mh-timepicker">
								<TimeInput v-model="timeFrom" @input="onTimeFromChange" />
								<i class="mh-icon-watch"></i>
							</div>
						</div>
					</b-col>
					<b-col v-if="duration == 'time'" md="6">
						<label class="mh-label required">Time Out</label>
						<div class="mh-time-entry">
							<div v-if="duration == 'time'" class="mh-datepicker">
								<datepicker v-model="dateTo" :disabled-dates="{ from: (isEmployee ? moment().toDate() : undefined), to: moment(dateFrom).toDate() }" @input="onDateToChange" />
								<i class="mh-icon-calendar"></i>
							</div>
							<div class="pl-2 mh-timepicker">
								<TimeInput v-model="timeTo" @input="onTimeToChange" />
								<i class="mh-icon-watch"></i>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row v-if="!isTimeClockShift" class="m-0">
					<b-col lg="6" md="12">
						<label class="mh-label">Date</label>
						<div class="mh-time-entry">
							<div class="mh-datepicker">
								<datepicker v-model="dateFrom" :disabled-dates="isEmployee ? { from: moment().toDate() } : undefined" @input="onDateFromChange" />
								<i class="mh-icon-calendar"></i>
							</div>
						</div>
					</b-col>
					<b-col lg="6" md="12">
						<label class="mh-label">Time</label>
						<div class="mh-time-entry">
							<div class="pl-2 mh-timepicker">
								<TimeInput v-model="timeFrom" @input="onTimeFromChange" />
								<i class="mh-icon-watch"></i>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row v-if="!isTimeClockShift" class="m-0">
					<b-col lg="4" md="12">
						<label class="mh-label">Shift/Session Hours</label>
						<div class="mh-time-entry">
							<div class="mh-timepicker">
								<TimeInput v-model="consultHours" @input="calculateHours" />
								<i class="mh-icon-watch"></i>
							</div>
						</div>
					</b-col>
					<b-col lg="4" md="12">
						<label class="mh-label">Admin Hours</label>
						<div class="mh-time-entry">
							<div class="mh-timepicker">
								<TimeInput v-model="adminHours" @input="calculateHours" />
								<i class="mh-icon-watch"></i>
							</div>
						</div>
					</b-col>
					<b-col lg="4" md="12">
						<label class="mh-label">Travel Hours</label>
						<div class="mh-time-entry">
							<div class="mh-timepicker">
								<TimeInput v-model="travelHours" @input="calculateHours" />
								<i class="mh-icon-watch"></i>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row class="m-0">
					<b-col md="12">
						<label class="mh-label">Total Hours</label>
						<TimeInput v-model="totalHours" @input="onTotalHoursChange" class="input total-hours" :disabled="duration == 'time'" />
					</b-col>
				</b-row>
				<b-row class="m-0">
					<b-col v-if="isEmployee" md="6">
						<label class="mh-label required">Participant/Customer</label>
						<div class="field-with-icon">
							<vue-typeahead-bootstrap :data="customers"
													 :serializer="s => s.name"
													 @hit="($event) => {customerId = $event.id; itemId = null; $refs.itemId.inputValue = ''; getClientServices();}"
													 @keyup="($event) => {
														if($refs.customerId.inputValue == '') {
															customerId = null;
															itemId = null;
															$refs.itemId.inputValue = '';
														}
													 }"
													 autocomplete="off"
													 :showOnFocus="true"
													 :minMatchingChars="1"
													 ref="customerId"></vue-typeahead-bootstrap>
							<i class="mh-icon-search"></i>
						</div>
					</b-col>
					<b-col :md="`${(isEmployee ? '6' : '12')}`">
						<label :class="`mh-label${isTimeClockShift ? '' : ' required'}`">Item</label>
						<div class="field-with-icon">
							<vue-typeahead-bootstrap :data="customerId == null ? [] : clientServices"
													 :serializer="s => s.service"
													 @hit="itemId = $event.serviceid"
													 @keyup="($event) => { $refs.itemId.inputValue != '' ? '' : itemId = null }"
													 autocomplete="off"
													 :showOnFocus="true"
													 :minMatchingChars="1"
													 :placeholder="customerId == null ? 'Select a customer first' : (clientServices.length < 1 ? 'No items available' : '')"
													 ref="itemId"></vue-typeahead-bootstrap>
							<i class="mh-icon-search"></i>
						</div>
					</b-col>
				</b-row>
			</fieldset>
			<b-row v-if="customer != null && customer.risknotification != ''" class="m-0">
				<b-col cols="12">
					<b-alert show variant="danger"><b>Risk:</b> {{customer.risknotification}}</b-alert>
				</b-col>
			</b-row>
			<b-row v-if="customer != null && customer.generalnotes != ''" class="m-0">
				<b-col cols="12">
					<b-alert show variant="info"><b>Formulation:</b> {{customer.generalnotes}}</b-alert>
				</b-col>
			</b-row>
			<b-row v-if="isEmployee" class="m-0">
				<b-col md="12">
					<label class="mh-label">Notes</label>
					<textarea class="form-control" v-model="notes" :disabled="isTimesheetApproved"></textarea>
				</b-col>
			</b-row>
			<fieldset :disabled="isFormDisabled">
				<b-row class="m-0">
					<b-col md="4">
						<label class="mh-label">Used Company Car</label>
						<div class="switches-container">
							<input type="radio" id="usedCompanyCarNo" value="0" v-model="usedCompanyCar" checked="checked" />
							<input type="radio" id="usedCompanyCarYes" value="1" v-model="usedCompanyCar" />
							<label for="usedCompanyCarNo">No</label>
							<label for="usedCompanyCarYes">Yes</label>
							<div class="switch-wrapper">
								<div class="switch">
									<div>No</div>
									<div>Yes</div>
								</div>
							</div>
						</div>
					</b-col>
					<b-col md="4">
						<label class="mh-label">Vehicle</label>
						<b-select v-model="vehicle" :disabled="usedCompanyCar === '0'" :options="vehicleOptions" text-field="name" value-field="id"></b-select>
					</b-col>
					<b-col md="4">
						<label class="mh-label">Vehicle Registration Number</label>
						<input type="text" v-model="vehicleRegistrationNumber" />
					</b-col>
				</b-row>
				<b-row class="m-0">
					<b-col md="3">
						<label class="mh-label">Odometer Start</label>
						<input type="number" v-model="odometerStart" @input="calculateTravelKms" :disabled="usedCompanyCar === '0'" />
					</b-col>
					<b-col md="3">
						<label class="mh-label">Odometer End</label>
						<input type="number" v-model="odometerEnd" @input="calculateTravelKms" :disabled="usedCompanyCar === '0'" />
					</b-col>
					<b-col md="3">
						<label class="mh-label">Travel KM</label>
						<input type="number" v-model="travelKm" @change="travelKm = Math.floor(parseFloat(travelKm) * 10) / 10" step="0.1" :disabled="usedCompanyCar === '1'" />
					</b-col>
					<b-col md="3">
						<label class="mh-label">Transport KM</label>
						<input type="number" v-model="transportKm" @change="transportKm = Math.floor(parseFloat(transportKm) * 10) / 10" step="0.1" />
					</b-col>
				</b-row>
			</fieldset>
			<b-row class="mr-0 ml-0 mh-action-nav">
				<b-col cols="6">
					<button class="btn btn-default btn-grey" @click="closeForm" :disabled="isFormDisabled">Close</button>
				</b-col>
				<b-col cols="6">
					<button class="btn btn-default" @click="saveRecord" :disabled="isTimesheetApproved || isFormDisabled">Save</button>
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
	import ProfileImage from "./ProfileImage"
	import TimeInput from "./controls/TimeInput"
	import moment from "moment"

	export default {
		name: 'TimesheetForm',
		components: {
			ProfileImage,
			TimeInput
		},
		props: {
			data: null
		},
		data: function () {
			return {
				timesheetId: 0,
				serviceScheduleId: 0,
				duration: "time",
				currentlyWorking: false,
				name: null,
				dateFrom: new Date(),
				timeFrom: "",
				dateTo: new Date(),
				timeTo: "",
				consultHours: "",
				adminHours: "",
				travelHours: "",
				totalHours: "",
				customerId: null,
				itemId: null,
				notes: null,
				usedCompanyCar: "0",
				vehicle: "",
				vehicleRegistrationNumber: "",
				odometerStart: "",
				odometerEnd: "",
				travelKm: 0,
				transportKm: 0
			}
		},
		mounted() {
			this.setFormValues()
		},
		watch: {
			data: {
				immediate: true,
				handler(newValue, oldValue) {
					this.setFormValues()
				}
			}
		},
		computed: {
			clientServices: function () {
				return this.$store.state.ClientServices.clientServices
			},
			profile: function () {
				return this.$store.state.Profile.profile
			},
			timeClockShifts: function () {
				return this.$store.state.Shifts.timeClockShifts
			},
			customers: function () {
				return this.$store.state.Customers.customers
			},
			customer: function () {
				return this.customers.filter(x => x.id === this.customerId)[0]
			},
			vehicles: function () {
				return this.$store.state.Vehicles.vehicles
			},
			vehicleOptions: function () {
				var vehicles = this.vehicles.slice()

				vehicles.unshift({ name: "", value: 0 })

				return vehicles
			},
			isEmployee: function () {
				return this.profile.accounttype == 2
			},
			isClient: function () {
				return this.profile.accounttype == 3
			},
			profilePicture: function () {
				return this.profile.profilepic
			},
			currentTimeClockShift: function () {
				var currentTimeClockShift = null

				if (this.timeClockShifts != null && this.timeClockShifts.length > 0) {
					currentTimeClockShift = this.timeClockShifts.filter(x => {
						var startTime = moment(x.servicedate, "D/MM/YYYY h:mm:ss A")

						return moment().isSameOrAfter(startTime) && x.clockouttime == ""
					})[0]
				}

				return currentTimeClockShift
			},
			isCurrentlyWorking: function () {
				return this.currentlyWorking
			},
			isTimeClockShift: function () {
				return this.currentlyWorking || (this.data != null && this.data.istimeclock)
			},
			isEditing: function () {
				return this.serviceScheduleId != 0
			},
			isFormDisabled: function () {
				return (this.isEditing && this.isClient) || (this.data != null && this.data.timesheetapproved == "True")
			},
			isTimesheetApproved: function () {
				return this.data != null && this.data.timesheetapproved == "True"
			},
			isTimesheetIdValid: function () {
				return true
			},
			isNameValid: function () {
				if (this.isTimeClockShift && (this.name == null || this.name == "")) {
					this.$store.commit("Toasts/showError", { title: "Name", content: "Name is required" })

					return false
				}

				return true
			},
			isDateFromValid: function () {
				if (this.dateFrom == null) {
					this.$store.commit("Toasts/showError", { title: "Time In Date", content: "Time In date is required" })

					return false
				}

				return true
			},
			isTimeFromValid: function () {
				if (this.timeFrom == "") {
					this.$store.commit("Toasts/showError", { title: "Time In Time", content: "Time In time is required" })

					return false
				}

				return true
			},
			isDateToValid: function () {
				if (!this.isTimeClockShift)
					return true

				if (this.dateTo == null) {
					this.$store.commit("Toasts/showError", { title: "Time Out Date", content: "Time Out date is required" })

					return false
				}

				return true
			},
			isTimeToValid: function () {
				if (!this.isTimeClockShift)
					return true

				if (this.isTimeClockShift
					&& this.currentTimeClockShift != null
					&& this.timesheetId != this.currentTimeClockShift.timesheetid) {
					this.$store.commit("Toasts/showError", { title: "Currently Working", content: "Cannot start new Time Clock entry. Already on the clock!" })

					return false
				}

				if (this.isTimeClockShift
					&& this.totalHours == "00:00") {
					this.$store.commit("Toasts/showError", { title: "Total Hours", content: "Total Hours Cannot be 00:00" })

					return false
				}

				if (this.isTimeClockShift) {
					return true
				}

				if (this.duration == "duration"
					&& this.totalHours == "00:00") {
					this.$store.commit("Toasts/showError", { title: "Total Hours", content: "Total Hours Cannot be 00:00" })

					return false
				}

				if (this.duration == "duration") {
					return true
				}

				if (this.isTimeClockShift) {
					return true
				}

				if (this.timeTo == null) {
					this.$store.commit("Toasts/showError", { title: "Time Out Time", content: "Time Out time is required" })

					return false
				}

				if (moment(this.dateFrom).format("YYYY-MM-DD") == moment(this.dateTo).format("YYYY-MM-DD")
					&& moment.duration(this.totalHours).asHours() > 24) {
					this.$store.commit("Toasts/showError", { title: "Total Hours", content: "Total Hours in 1 day cannot be more than 24" })

					return false
				}

				if (moment(this.dateFrom).format("YYYY-MM-DD") == moment(this.dateTo).format("YYYY-MM-DD")
					&& this.timeFrom == ""
					&& this.timeTo == "") {
					this.$store.commit("Toasts/showError", { title: "Time Out Time", content: "Time Out time cannot be the same as Time In time" })

					return false
				}

				var from = moment(`${moment(this.dateFrom).format("YYYY-MM-DD")} ${this.timeFrom}`, "YYYY-MM-DD hh:mm")
				var to = moment(`${moment(this.dateTo).format("YYYY-MM-DD")} ${this.timeTo}`, "YYYY-MM-DD HH:mm")

				if (to.isSameOrBefore(from)) {
					this.$store.commit("Toasts/showError", { title: "Time Out Time", content: "Time Out time cannot be before Time In time" })

					return false
				}

				return true
			},
			isConsultHoursValid: function () {
				if (this.isTimeClockShift)
					return true

				if (this.consultHours == null) {
					this.$store.commit("Toasts/showError", { title: "Consult Hours", content: "Consult Hours is required" })

					return false
				}

				return true
			},
			isAdminHoursValid: function () {
				if (this.isTimeClockShift)
					return true

				if (this.adminHours == null) {
					this.$store.commit("Toasts/showError", { title: "Admin Hours", content: "Admin Hours is required" })

					return false
				}

				return true
			},
			isTravelHoursValid: function () {
				if (this.isTimeClockShift)
					return true

				if (this.travelHours == null) {
					this.$store.commit("Toasts/showError", { title: "Travel Hours", content: "Travel Hours is required" })

					return false
				}

				return true
			},
			isTotalHoursValid: function () {
				if (this.totalHours == null) {
					this.$store.commit("Toasts/showError", { title: "Total Hours", content: "Total Hours is required" })

					return false
				}

				return true
			},
			isCustomerIdValid: function () {
				if (this.customerId == null) {
					this.$store.commit("Toasts/showError", { title: "Customer", content: "Customer is required" })

					return false
				}

				return true
			},
			isItemIdValid: function () {
				if (this.isTimeClockShift) {
					return true
				}

				if (this.itemId == null) {
					this.$store.commit("Toasts/showError", { title: "Item", content: "Item is required" })

					return false
				}

				return true
			},
			isNotesValid: function () {
				return true
			},
			isUsedCompanyCarValid: function () {
				return true
			},
			isVehicleValid: function () {
				return true
			},
			isVehicleRegistrationNumberValid: function () {
				return true
			},
			isOdometerStartValid: function () {
				if (this.usedCompanyCar === "1" && this.odometerStart === "") {
					this.$store.commit("Toasts/showError", { title: "Odometer Start", content: "Odometer Start is required" })

					return false
				}

				return true
			},
			isOdometerEndValid: function () {
				if (this.usedCompanyCar === "1" && this.odometerEnd === "") {
					this.$store.commit("Toasts/showError", { title: "Odometer End", content: "Odometer End is required" })

					return false
				}
				
				if (parseFloat(this.odometerEnd) < parseFloat(this.odometerStart)) {
					this.$store.commit("Toasts/showError", { title: "Odometer End", content: "Odometer End must be greater than Odometer Start" })

					return false
				}

				return true
			},
			isTravelKmValid: function () {
				return true
			},
			isTransportKmValid: function () {
				return true
			}
		},
		methods: {
			getClientServices: function () {
				this.$store.dispatch("ClientServices/getClientServices", { customerId: this.customerId, date: moment(this.dateFrom).format("YYYY-MM-DD") })
			},
			setFormValues: function () {
				this.duration = "time"
				
				if (this.data != null) {
					if (this.data.timesheetid != null)
						this.timesheetId = this.data.timesheetid

					if (this.currentTimeClockShift != null)
						this.currentlyWorking = this.currentTimeClockShift.timesheetid == this.timesheetId || (this.data != null && this.data.istimeclock)

					if (this.data.servicescheduleid != null)
						this.serviceScheduleId = this.data.servicescheduleid

					if (this.data.shifttask != null)
						this.name = this.data.shifttask

					if (this.data.servicedate != null)
						this.dateFrom = moment(this.data.servicedate, "D/MM/YYYY h:mm:ss A").toDate()

					if (this.data.servicedate != null)
						this.timeFrom = moment(this.data.servicedate, "D/MM/YYYY h:mm:ss A").format("HH:mm")

					if (this.data.enddate != null)
						this.dateTo = moment(this.data.enddate, "D/MM/YYYY h:mm:ss A").toDate()

					if (this.data.enddate != null)
						this.timeTo = moment(this.data.enddate, "D/MM/YYYY h:mm:ss A").format("HH:mm")

					if (this.data.servicehours != null && this.data.servicehours != "")
						this.consultHours = moment.duration(this.data.servicehours, "hours").format("HH:mm", { trim: false })

					if (this.data.adminhours != null && this.data.adminhours != "")
						this.adminHours = moment.duration(this.data.adminhours, "hours").format("HH:mm", { trim: false })

					if (this.data.travelhours != null && this.data.travelhours != "")
						this.travelHours = moment.duration(this.data.travelhours, "hours").format("HH:mm", { trim: false })

					if (this.data.servicedate != null && this.data.enddate != null)
						this.calculateHours()
					
					if (this.isEmployee) {
						if (this.data.clientid != null) {
							var client = this.customers.filter(x => x.id == this.data.clientid)[0]

							if (client != null) {
								this.customerId = client.id
								
								if (this.$refs.customerId != null)
									this.$refs.customerId.inputValue = client.name
							}
						}
					}
					else {
						this.customerId = this.profile.userid
					}

					if (this.data.servicetypeid != null) {
						var clientService = this.clientServices.filter(x => x.serviceid == this.data.servicetypeid)[0]

						if (clientService != null) {
							this.itemId = clientService.serviceid

							if (this.$refs.itemId != null)
								this.$refs.itemId.inputValue = clientService.service
						}
					}
					
					if (this.data.shiftnotes != null)
						this.notes = this.data.shiftnotes

					if (this.data.usedcompanycar != null)
						this.usedCompanyCar = this.data.usedcompanycar

					if (this.data.vehicleid != null)
						this.vehicle = this.data.vehicleid

					if (this.data.vehicleregistrationnumber != null)
						this.vehicleRegistrationNumber = this.data.vehicleregistrationnumber

					if (this.data.odometerstart != null)
						this.odometerStart = this.data.odometerstart

					if (this.data.odometerend != null)
						this.odometerEnd = this.data.odometerend

					if (this.data.timesheettraveldistance != null)
						this.travelKm = parseFloat("0" + this.data.timesheettraveldistance)

					if (this.data.timesheettransportdistance != null)
						this.transportKm = parseFloat("0" + this.data.timesheettransportdistance)
				}
				else {
					this.currentlyWorking = false
					this.timesheetId = 0
					this.serviceScheduleId = 0
					this.name = null
					this.dateFrom = new Date()
					this.timeFrom = ""
					this.dateTo = new Date()
					this.timeTo = ""
					this.consultHours = ""
					this.adminHours = ""
					this.travelHours = ""
					this.totalHours = ""
					this.customerId = this.isEmployee ? null : this.profile.userid

					if (this.$refs.customerId != null)
						this.$refs.customerId.inputValue = ""

					this.itemId = null

					if (this.$refs.itemId != null)
						this.$refs.itemId.inputValue = ""

					this.notes = null
					this.usedCompanyCar = "0"
					this.vehicle = ""
					this.vehicleRegistrationNumber = ""
					this.odometerStart = ""
					this.odometerEnd = ""
					this.travelKm = 0
					this.transportKm = 0
				}
			},
			resetTimes: function () {
				this.dateTo = this.dateFrom
				this.timeTo = this.timeFrom
				this.totalHours = "00:00"
			},
			onDurationChange: function () {
				if (this.data != null && this.data.status == "2")
					return

				this.currentlyWorking = false
				this.resetTimes()
				this.calculateHours()
			},
			onStatusClick: function () {
				if (this.data != null && this.data.status == "2")
					return

				this.currentlyWorking = !this.currentlyWorking

				if (this.currentlyWorking) {
					this.timeFrom = moment().format("HH:mm")
				}
				else {
					this.timeFrom = ""
				}

				this.resetTimes()
				this.calculateHours()
			},
			onDateFromChange: function () {
				if (this.isTimeClockShift) {
					this.resetTimes()
				}

				this.getClientServices()()
				this.calculateHours()
			},
			onTimeFromChange: function () {
				if (this.isTimeClockShift) {
					this.resetTimes()
				}

				this.calculateHours()
			},
			onDateToChange: function () {
				this.calculateHours()
			},
			onTimeToChange: function () {
				this.calculateHours()
			},
			onTotalHoursChange: function () {
				this.calculateHours()
			},
			calculateHours: function () {
				if (!this.isTimeClockShift) {
					var consultHours = moment.duration(this.consultHours).asHours()
					var adminHours = moment.duration(this.adminHours).asHours()
					var travelHours = moment.duration(this.travelHours).asHours()

					this.totalHours = moment.duration(consultHours + adminHours + travelHours, "hours").format("HH:mm", { trim: false })

					return
				}

				if (this.duration == "duration") {
					var totalHours = moment(this.totalHours, "HH:mm")
					var toDate = moment(`${moment(this.dateFrom).format("YYYY-MM-DD ")} ${this.timeFrom}`, "YYYY-MM-DD HH:mm")
						.add(totalHours.format("HH"), "hours")
						.add(totalHours.format("mm"), "minutes")

					this.dateTo = toDate.toDate()
					this.timeTo = toDate.format("HH:mm")
				}
				else {
					var from = moment(`${moment(this.dateFrom).format("YYYY-MM-DD")} ${this.timeFrom}`, "YYYY-MM-DD HH:mm")
					var to = moment(`${moment(this.dateTo).format("YYYY-MM-DD")} ${this.timeTo}`, "YYYY-MM-DD HH:mm")

					this.totalHours = moment.duration(to.diff(from)).format("HH:mm", { trim: false })
				}
			},
			calculateTravelKms: function () {
				if (this.odometerEnd === "")
					return

				this.travelKm = this.odometerEnd - this.odometerStart
			},
			closeForm: function () {
				this.$emit("close-form")
			},
			isFormValid: function () {
				return this.isTimesheetIdValid
					&& this.isDateFromValid
					&& this.isTimeFromValid
					&& this.isDateToValid
					&& this.isTimeToValid
					&& this.isTotalHoursValid
					&& this.isCustomerIdValid
					&& this.isItemIdValid
					&& this.isNotesValid
					&& this.isUsedCompanyCarValid
					&& this.isVehicleValid
					&& this.isVehicleRegistrationNumberValid
					&& this.isOdometerStartValid
					&& this.isOdometerEndValid
					&& this.isTravelKmValid
					&& this.isTransportKmValid
			},
			saveRecord: function () {
				if (!this.isFormValid())
					return

				var totalHours = moment.duration(this.totalHours).asHours()
				var dateFrom = moment(`${moment(this.dateFrom).format("YYYY-MM-DD")} ${this.timeFrom}`, "YYYY-MM-DD HH:mm")
				var dateTo = moment(`${moment(this.dateTo).format("YYYY-MM-DD")} ${this.timeTo}`, "YYYY-MM-DD HH:mm")

				if (!this.isTimeClockShift)
					dateTo = moment(dateFrom.toDate())
						.add(totalHours, "hours")

				var status = 0

				if (this.serviceScheduleId != 0 && !this.isTimeClockShift)
					status = 2

				var additionalRosterComments = null

				if (this.isTimeClockShift)
					additionalRosterComments = "TimeClock"

				var parameters = {
					timesheetId: this.timesheetId,
					hasShift: this.serviceScheduleId != 0,
					shiftId: this.serviceScheduleId,
					shiftName: this.isTimeClockShift ? this.name : null,
					userId: this.profile.userid,
					clientId: this.customerId,
					dateFrom: dateFrom.format("YYYY-MM-DD hh:mm:ss a"),
					dateTo: dateTo.format("YYYY-MM-DD hh:mm:ss a"),
					consultHours: moment.duration(this.consultHours).asHours(),
					adminHours: moment.duration(this.adminHours).asHours(),
					travelHours: moment.duration(this.travelHours).asHours(),
					totalHours: totalHours,
					usedCompanyCar: this.usedCompanyCar,
					vehicle: this.vehicle,
					vehicleRegistrationNumber: this.vehicleRegistrationNumber,
					odometerStart: "0" + this.odometerStart,
					odometerEnd: "0" + this.odometerEnd,
					travelKm: this.travelKm,
					transportKm: this.transportKm,
					serviceTypeId: this.itemId == null && this.isTimeClockShift ? -1 : this.itemId,
					billable: this.data != null ? !this.data.istimeclock : true,
					serviceScheduleStatus: status,
					noteTagIds: "",
					notes: "" + this.notes,
					cancellationPolicyId: "0",
					additionalRosterComments: additionalRosterComments,
					SendEmailNotification: false,
					CreateShiftWithErrors: true
				}

				var $this = this

				this.$store.dispatch("Shifts/createTimesheet", parameters).then(function (response) {
					$this.$emit("save-form", response)

					$this.serviceScheduleId = response.shiftid
					$this.timesheetId = response.timesheetid
				})
			}
		}
	}
</script>

<style scoped>
	.mh-time-entry .mh-datepicker {
		width: 100% !important;
	}

	.total-hours {
		font-weight: bold !important;
		color: #000 !important;
		font-size: 18px !important;
	}
</style>